import React from 'react';

const CONFIG = {
  approved: { cls: 'badge-approved', dot: '#52B788' },
  pending:  { cls: 'badge-pending',  dot: '#D97706' },
  rejected: { cls: 'badge-rejected', dot: '#EF4444' },
  // Withdrawn by the person / cancelled by an approver (kept in the history)
  withdrawn: { cls: 'badge-rejected', dot: '#A0A0A0', label: 'Withdrawn' },
  cancelled: { cls: 'badge-rejected', dot: '#A0A0A0', label: 'Cancelled' },
};

export function StatusBadge({ status }) {
  const c = CONFIG[status] || CONFIG.pending;
  return (
    <span className={c.cls}>
      <span style={{ width: 6, height: 6, borderRadius: '50%', background: c.dot, display: 'inline-block', flexShrink: 0 }} />
      {c.label ?? (status.charAt(0).toUpperCase() + status.slice(1))}
    </span>
  );
}